import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-0 p-4 pb-0" }
const _hoisted_2 = {
  class: "col-12 d-flex align-items-center",
  "with.bind": "physicianRequired"
}
const _hoisted_3 = {
  key: 0,
  class: "col-5 col-lg-7 p-1 pt-4"
}
const _hoisted_4 = {
  key: 1,
  class: "col-5 col-lg-7 p-1 pt-4"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "form-group col-12 col-md-5 col-lg-4" }
const _hoisted_8 = { class: "form-check custom-checkbox custom-border physician-required-section" }
const _hoisted_9 = ["id", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, " Referral Source", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreatePhysicianRow = _resolveComponent("CreatePhysicianRow")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Physician Information",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referral.physicianRequiredArray, (physicianRequired, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 row g-0 border-bottom",
            key: index
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_CreatePhysicianRow, {
                "physician-required": physicianRequired,
                "physician-index": index,
                referral: _ctx.referral
              }, null, 8 /* PROPS */, ["physician-required", "physician-index", "referral"]),
              (index == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("i", {
                      class: "fa fa-plus fa-2x text-success",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addPhysician()))
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              (index != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("i", {
                      class: "fa fa-times fa-2x text-danger",
                      onClick: ($event: any) => (_ctx.removePhysician(index))
                    }, null, 8 /* PROPS */, _hoisted_5)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: `ref-source-${index}`,
                    ref_for: true,
                    ref: "radio",
                    class: "form-check-input au-target physician-required-input",
                    onChange: ($event: any) => (_ctx.radioChanged(index))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `ref-source-${index}`
                  }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                ])
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}